import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@hooks/app/modal.hook'

import { Modal } from '@components/Modal'
import { Input } from '@components/Input'

import { useCreateUser } from '@hooks/user/create-user.hook'

import { Container } from './add-user.styled'

export const AddUserPage = (): JSX.Element => {
  const { hideModal } = useModal()

  const { t } = useTranslation()

  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  const { createUser } = useCreateUser()

  return (
    <Modal
      title={t('modules_admin_pages_add_user_title')}
      onSubmitLabel={t('modules_admin_pages_add_user_button_add-user')}
      onClose={() => {
        hideModal('add_user')
      }}
      onSubmit={() => {
        createUser({
          firstName,
          lastName,
          email,
        })

        hideModal('add_user')
      }}
    >
      <Container>
        <Input
          autoFocus
          required
          label={t('modules_admin_pages_add_user_label_user-first_name')}
          placeholder={t('modules_admin_pages_add_user_placeholder_user-first_name')}
          value={firstName}
          onChange={(v) => setFirstName(v)}
        />
        <Input
          required
          label={t('modules_admin_pages_add_user_label_user-last_name')}
          placeholder={t('modules_admin_pages_add_user_placeholder_user-last_name')}
          value={lastName}
          onChange={(v) => setLastName(v)}
        />
        <Input
          required
          type="email"
          label={t('modules_admin_pages_add_user_label_user-email')}
          placeholder={t('modules_admin_pages_add_user_placeholder_user-email')}
          value={email}
          onChange={(v) => setEmail(v)}
        />
      </Container>
    </Modal>
  )
}
